<template>
  <pa-dialog
    :title="value['.key'] ? 'Edit' : 'Create'"
    :subtitle="expense.name"
    :positive-text="value['.key'] ? 'Save' : 'Create'"
    negative-text
    :show="showDialog"
    @positive="saveActual"
    @cancel="cancel"
  >
    <v-flex xs12>
      <v-text-field
        v-model.number="value.amount"
        label="Amount"
        :suffix="expense.currency"
        required
      />
    </v-flex>

    <v-flex xs12>
      <pa-date-picker
        v-model="value.date"
        label="Date"
      />
    </v-flex>
  </pa-dialog>
</template>

<script>
import PaDatePicker from '@/components/shared/PaDatePicker'
import PaDialog from '@/components/shared/PaDialog'

export default {
  components: {
    PaDatePicker,
    PaDialog
  },
  props: {
    value: {
      type: Object,
      default: () => { return {} }
    },
    expense: {
      type: Object,
      default: () => { return {} }
    },
    show: Boolean
  },
  data () {
    return {}
  },
  computed: {
    showDialog: {
      get () { return this.show },
      set (value) {
        if (!value) {
          this.$emit('update:show')
        }
      }
    }
  },
  methods: {
    saveActual () {
      this.expense.save()
      this.showDialog = false
    },
    cancel () {
      this.expense.reset()
      this.showDialog = false
    }
  }
}
</script>
